import { AfterViewInit, Directive, Input, OnDestroy, ViewChild } from '@angular/core';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { Chart, IPointRenderEventArgs } from '@syncfusion/ej2-angular-charts';
import { Subscription } from 'rxjs';
import { delay, map, tap } from 'rxjs/operators';
import { Themes } from '../../shared/themes';

@Directive()
export class DashboardBaseComponent implements AfterViewInit, OnDestroy {

  @Input() width: string;
  @Input() height: string;

  @ViewChild('chart') chart: Chart;

  // == INTERMEDIATE ====================================================

  theme$ = this.storageService.theme$.pipe(
    map(theme => this.getTheme(theme))
  );

  // == SUBSCRIPTION ====================================================

  baseSubscription = new Subscription();

  // == LIFECYCLE =======================================================

  constructor(protected storageService: StorageService) {};

  ngAfterViewInit() {
    this.baseSubscription.add(this.theme$.pipe(
      delay(50),
      tap(_ => this.chart?.refresh())
    ).subscribe())
  }

  ngOnDestroy() {
    this.baseSubscription.unsubscribe();
  }

  // == HELPERS ==========================================

  public pointRender(args: IPointRenderEventArgs): void {
    const seriesColor: string[] = ['#00bdae', '#7bb4eb', '#357cd2', '#e56590', '#f8b883', '#70ad47', '#dd8abd', '#7f84e8', '#cadb69', '#ea7a57'];
    args.fill = seriesColor[args.point.index];
  };

  getTheme(theme: string) {
    if (theme === Themes.dark) {
      return 'MaterialDark';
    } else if (theme === Themes.light) {
      return 'Material';
    }
  }
}
